import {Card, CardBody, CardHeader, Col, FormGroup, Label, Row, Table,Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal, ModalBody,} from "reactstrap";
import React, {Fragment, useState} from "react";
import {downloadOrderInvoice, downloadOrderPdf, unSetTrackingData} from "../../store/orderSlice";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";


export const Item = (props) => {
    const {orderState,orderId,retrieveTrackingDetails,authData}=props;
    const dispatch = useDispatch();
    const currentUser = useSelector(({authReducer}) => authReducer.data.user);
    const userState =  useSelector(({authReducer}) => authReducer.data);
    const [downloading, setDownloading] = useState({});
    const processPDFDownload =(name)=>{
        const data={
            id:orderId,
            params: {
                name:name,
                seller:authData.defaultSeller?.value}
        }
        console.log(data);
        setDownloading(prev => ({...prev, [name]: true}));
        dispatch(downloadOrderPdf(data)).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.payload]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${orderState.data?orderState.data.order_name:"-"}_${name.replace(/\s+/g, '-')}_${(new Date().toJSON().slice(0,10))}.pdf`); //or any other extension
            document.body.appendChild(link);
            link.click();
        }).finally(() => {
            setDownloading(prev => ({...prev, [name]: false}));
        });
    }
    const handlePackageSlipDownload =()=>{
        processPDFDownload("Package Slip");
    }
    const handlePickingTicketDownload =()=>{
        processPDFDownload("Picking Ticket");
    }
    const handleInvoiceDownload =()=>{
        const data={
            id:orderId,
            params: {
                seller:authData.defaultSeller?.value}
        }
        setDownloading(prev => ({...prev, Invoice: true}));
        dispatch(downloadOrderInvoice(data)).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.payload]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${orderState.data?orderState.data.order_name:"-"}_Invoice_${(new Date().toJSON().slice(0,10))}.pdf`); //or any other extension
            document.body.appendChild(link);
            link.click();
        }).finally(() => {
            setDownloading(prev => ({...prev, Invoice: false}));
        });
    }
    const noTracking =()=>{
        dispatch(unSetTrackingData());
        toast.warning("Tracking details are required to be added to this item", {
            position: toast.POSITION.TOP_RIGHT,
        });
    }
    const [imageModal, setImageModal] = useState({ isOpen: false, url: null, title: '' });

    const handleImageClick = (url, title) => {
        setImageModal({ isOpen: true, url, title });
    };

    const handleImageDownload = () => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', imageModal.url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
            const url = window.URL.createObjectURL(new Blob([xhr.response]));
            const link = document.createElement('a');
            link.href = url;
            const fileName = imageModal.url.split('/').pop().split('?')[0] || 'image.png';
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        };
        xhr.onerror = () => {
            toast.error("Failed to download image", { position: toast.POSITION.TOP_RIGHT });
        };
        xhr.send();
    };
    return (
        <Fragment>
            <Col sm="12">
                <Card className="ribbon-wrapper">
                    <CardBody>
                        <div className="ribbon ribbon-clip h5 ribbon-dark">Items from Order {orderState.data?orderState.data.order_name:"-"}</div>
                        {orderState.data?orderState.data.customer_name!=="-" && <div className="mt-2 d-flex justify-content-end">
                            <div className="p-2">
                                <button onClick={handleInvoiceDownload} disabled={downloading["Invoice"]} className="btn btn-success btn-block">
                                    {downloading["Invoice"] && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                                    Invoice
                                </button>
                            </div>
                            {(currentUser.permission).includes('Create Packing Slips') && <div className="p-2">
                                <button onClick={handlePackageSlipDownload} disabled={downloading["Package Slip"]} className="btn btn-danger btn-block">
                                    {downloading["Package Slip"] && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                                    Packing Slip
                                </button>
                            </div>}
                            {(currentUser.permission).includes('Create Picking Ticket') && <div className="p-2">
                                <button onClick={handlePickingTicketDownload} disabled={downloading["Picking Ticket"]} className="btn btn-primary btn-block">
                                    {downloading["Picking Ticket"] && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                                    Picking Ticket
                                </button>
                            </div>}
                            {/* <div className="p-2">
                            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                            <DropdownToggle caret color="primary" className="btn btn-primary">Supplier</DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem>Foo Action</DropdownItem>
                                    <DropdownItem>Bar Action</DropdownItem>
                                    <DropdownItem>Quo Action</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                            </div> */}
                        </div>:""}

                        <div className="table-responsive">
                            <Table>
                                <thead className="thead-light">
                                    <tr>
                                        <th scope="col" style={{ whiteSpace: 'nowrap',width:'40%' }}>Product</th>
                                        <th scope="col" style={{ whiteSpace: 'nowrap',width:'15%' }}>Status</th>
                                        <th scope="col" style={{ whiteSpace: 'nowrap',width:'15%' }}>Return Status</th>
                                        <th scope="col" style={{ whiteSpace: 'nowrap',width:'10%', textAlign: 'right' }}>Quantity</th>
                                        <th scope="col" style={{ whiteSpace: 'nowrap',width:'10%', textAlign: 'right' }}>Price (£)</th>
                                        <th scope="col" style={{ whiteSpace: 'nowrap',width:'10%', textAlign: 'right' }}>Total (£)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {(orderState.list).length > 0?(orderState.list.map((item,index)=>{
                                    const visibleProps = item.properties ? item.properties.filter(p => p.name && !p.name.startsWith('_') && !(p.name === 'Fabric' && p.value === item.name)) : [];
                                    const artworkUrl = item.properties ? item.properties.find(p => p.name === '_artwork_url')?.value : null;
                                    const previewUrl = item.properties ? item.properties.find(p => p.name === '_preview_url')?.value : null;
                                    const settingsRaw = item.properties ? item.properties.find(p => p.name === '_settings')?.value : null;
                                    let settings = null;
                                    try { if (settingsRaw) settings = JSON.parse(settingsRaw); } catch(e) {}

                                    return (<React.Fragment key={index}>
                                    <tr>
                                        <td className="col-2">
                                        <div className="row">
                                            <div className="col-md-2">
                                                {previewUrl ? (
                                                    <img width="40" className="img-fluid" src={previewUrl} alt="Preview"/>
                                                ) : (
                                                    <img width="40" className="img-fluid" src={item.image}/>
                                                )}
                                            </div>
                                            <div className="col-md-9">
                                                <div className="row">
                                                    <p className={'font-primary'}>{item.sku}</p>
                                                </div>
                                                <div className="row">
                                                    {(() => {
                                                    if (item.status_id===1) {
                                                        return (
                                                            <i onClick={noTracking} style={{margin: 'auto', marginLeft: 0,}} className="fa fa-truck mr-1 text-primary"></i>
                                                        )
                                                    } else if (item.status_id===2) {
                                                        return (
                                                            <a onClick={() => {retrieveTrackingDetails(item.id)}} ><i className="fa fa-truck mr-1 text-success"></i></a>
                                                        )
                                                    } else {
                                                        return (
                                                            <i className="fa fa-truck mr-1 text-dark"></i>
                                                        )
                                                    }
                                                    })()}
                                                    {item.name}
                                                </div>
                                                {item.brand && item.brand !== '-' && <div className="row">
                                                    <p>{item.brand}</p>
                                                </div>}
                                                {item.colour && item.colour !== '-' && <div className="row">
                                                    <p>{item.colour}</p>
                                                </div>}
                                                {item.size && item.size !== '-' && <div className="row">
                                                    <p>{item.size}</p>
                                                </div>}
                                            </div>

                                        </div>

                                        </td>
                                        <td><div style={{marginTop: "2rem"}}>{item.status}</div></td>
                                        <td><div style={{marginTop: "2rem"}}>{item.return_status}</div></td>
                                        <td><div style={{marginTop: "2rem", textAlign: 'right'}}>{item.quantity}</div></td>
                                        <td><div style={{marginTop: "2rem", textAlign: 'right'}}>{item.price}</div></td>
                                        <td><div style={{marginTop: "2rem", textAlign: 'right'}}>{item.total_price}</div></td>
                                    </tr>
                                    {visibleProps.length > 0 && (
                                    <tr>
                                        <td colSpan="6" style={{paddingTop: 0, borderTop: 'none'}}>
                                            <div style={{background: '#f8f9fa', borderRadius: '4px', padding: '10px 15px', marginBottom: '5px'}}>
                                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px'}}>
                                                    <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px 25px', fontSize: '13px'}}>
                                                        {visibleProps.map((prop, pi) => (
                                                            <span key={pi}>
                                                                <strong>{prop.name}:</strong>{' '}{prop.value}
                                                            </span>
                                                        ))}
                                                    </div>
                                                    {(artworkUrl || previewUrl) && (
                                                        <div style={{display: 'flex', gap: '8px'}}>
                                                            {artworkUrl && <button className="btn btn-outline-primary btn-sm" style={{padding: '2px 10px', fontSize: '12px'}} onClick={() => handleImageClick(artworkUrl, 'Artwork')}><i className="fa fa-image mr-1"></i>Artwork</button>}
                                                            {previewUrl && <button className="btn btn-outline-info btn-sm" style={{padding: '2px 10px', fontSize: '12px'}} onClick={() => handleImageClick(previewUrl, 'Preview')}><i className="fa fa-eye mr-1"></i>Preview</button>}
                                                        </div>
                                                    )}
                                                </div>
                                                {settings && (
                                                    <div style={{marginTop: '6px', fontSize: '12px', color: '#666'}}>
                                                        <span><strong>Scale:</strong> {settings.scale}%</span>
                                                        {settings.rotation > 0 && <span style={{marginLeft: '15px'}}><strong>Rotation:</strong> {settings.rotation}°</span>}
                                                        <span style={{marginLeft: '15px'}}><strong>Repeat:</strong> {settings.repeatType}</span>
                                                        {settings.backgroundColor && <span style={{marginLeft: '15px'}}><strong>Background:</strong> {settings.backgroundColor}</span>}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    )}
                                    </React.Fragment>)
                                    })):null
                                }
                                    <tr></tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td className="font-weight-bold">Sub Total:</td>
                                        <td><div style={{textAlign: 'right'}}>{orderState.data?orderState.data.total_line_items_amount:""}</div></td>
                                    </tr>
                                    <tr>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td className="font-weight-bold">Discount:</td>
                                        <td><div style={{textAlign: 'right'}}>{orderState.data?orderState.data.total_discount:""}</div></td>
                                    </tr>
                                    {userState.user.role.name !== "Seller" ? (
                                    <tr>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td className="font-weight-bold">Shipping Charge:</td>
                                        <td><div style={{textAlign: 'right'}}>{orderState.data?orderState.data.shipping_charges:""}</div></td>
                                    </tr>
                                    ) : '' }
                                    <tr>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td className="font-weight-bold" style={{width: '20%'}}>Tax (20% VAT):</td>
                                        <td><div style={{textAlign: 'right'}}>{orderState.data?orderState.data.total_tax:""}</div></td>
                                    </tr>
                                    <tr>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td style={{borderStyle:"none"}}></td>
                                        <td className="font-weight-bold">Total:</td>
                                        {/* <td><div style={{textAlign: 'right'}}>{orderState.data?orderState.data.total_price:""}</div></td> */}
                                        <td>
                                            <div style={{textAlign: 'right'}}>
                                                {orderState.data
                                                    ? (parseFloat(orderState.data.total_tax || 0) + parseFloat(orderState.data.total_price || 0)).toFixed(2)
                                                    : ""}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </CardBody>
                </Card>
            </Col>
            <Modal isOpen={imageModal.isOpen} toggle={() => setImageModal({ ...imageModal, isOpen: false })} centered size="lg">
                <ModalBody style={{ padding: 0, position: 'relative' }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '10px 15px', background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                        <button className="btn btn-sm btn-outline-success" onClick={handleImageDownload} title="Download">
                            <i className="fa fa-download mr-1"></i>Download
                        </button>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => setImageModal({ ...imageModal, isOpen: false })} title="Close">
                            <i className="fa fa-times mr-1"></i>Close
                        </button>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px', background: '#fff' }}>
                        {imageModal.url && <img src={imageModal.url} alt={imageModal.title} style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }} />}
                    </div>
                </ModalBody>
            </Modal>
        </Fragment>
    );
};